import type { HdmgdjConfig } from "@/config/hdmgdjConfig";

interface HdmgdjDownloadCtaProps {
  config: HdmgdjConfig;
}

const HDMGDJ_LIE =
  "/images/mascot-cta.png";

export default function HdmgdjDownloadCta({ config }: HdmgdjDownloadCtaProps) {
  return (
    <section className="w-full bg-foreground-950 py-14 md:py-16">
      <div className="hdmgdj-container">
        <div className="relative bg-foreground-900 rounded-lg p-7 md:p-10 overflow-hidden">
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-background-50 text-[28px] md:text-[36px] leading-tight">
                现在就开始你的 黄豆魔改短剧 之旅
              </h2>
              <p className="mt-4 text-[15px] leading-8 text-background-200">
                {"海量魔改短剧已完成上架，"}
                <span className="text-primary-300 font-medium">{"黄豆魔改短剧APP下载"}</span>
                {"后即刻开追，新剧每日不断更新。"}
              </p>
              <a
                href={config.downloadUrl}
                rel="noopener noreferrer"
                className="mt-7 inline-flex items-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-foreground-950 text-[16px] font-label font-bold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-download-2-line text-xl" />
                前往官方下载地址
              </a>
            </div>

            <img
              src={HDMGDJ_LIE}
              alt="黄豆魔改短剧吉祥物趴姿"
              title="黄豆魔改短剧吉祥物"
              className="w-[180px] md:w-[220px] h-auto self-center lg:self-auto hdmgdj-float-slow"
            />
          </div>
        </div>
      </div>
    </section>
  );
}